import { Logo } from "@storytell/core";
import { Show } from "solid-js";
import { appBooted } from "./bootState";

const containerClass = () =>
  `${appBooted() ? "h-full" : "fixed inset-0 z-9999"} flex flex-col items-center justify-center gap-6 bg-canvas px-4 text-center`;

// The single loading transition: the Chief wordmark over a spinner with an
// optional caption. Before the app has shown content (cold open) it covers the
// viewport so it continues the boot splash; once content has rendered once it
// fills only its container, so an in-app navigation stays scoped to the content
// panel and the sidebar/top bar keep rendering. bg-canvas covers any stale
// content underneath. The flag flips on first real content mount (markAppBooted
// in the content views), not when a loader unmounts — so a cold load's
// intermediate loaders all stay full-screen until the page actually renders.
export const LogoLoading = (props: { label?: string }) => {
  return (
    <div class={containerClass()}>
      <Logo size={32} markClass="text-[#DEB332]" textClass="text-primary-text" />
      <div class="flex flex-col items-center gap-3">
        <div class="size-8 animate-spin rounded-full border-2 border-current border-t-transparent text-muted-text" />
        <Show when={props.label}>
          <p class="text-sm text-muted-text">{props.label}</p>
        </Show>
      </div>
    </div>
  );
};
